import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import type { CoursesDirectorySpace } from "@/react/types/CoursesDirectory";
import type { SearchSpace } from "@/react/types/Search/Space";
import { Typography } from "@circle-react-uikit/Typography";
import { CoursesList } from "./CoursesList";

export const ReorderCourses = () => {
  const { setValue, watch } = useFormContext();
  const courses = watch("courses");

  const reorder = (data: CoursesDirectorySpace[] | SearchSpace[]) => {
    setValue("courses", data, { shouldDirty: true });
  };
  return (
    <>
      <Typography.TitleMd color="text-darkest">
        {t("courses.directory.options_modal.reorder_courses.title")}
      </Typography.TitleMd>
      <Typography.BodyMd color="text-default">
        {t("courses.directory.options_modal.reorder_courses.subtitle")}
      </Typography.BodyMd>
      <CoursesList courses={courses} onSort={reorder} />
    </>
  );
};
